const footPrints = (xmlElement) => {
    const FootPrints = xmlElement.getElementsByTagName("cb:FootPrints")[0];

    const Count1Month = FootPrints.attributes?.Count1Month?.value ?? ''
    const Count3Months = FootPrints.attributes?.Count3Months?.value ?? ''
    const Count6Months = FootPrints.attributes?.Count6Months?.value ?? ''
    const Count12Months = FootPrints.attributes?.Count12Months?.value ?? ''
    let FootPrint = null
    if (xmlElement.getElementsByTagName("cb:FootPrint")) {
        FootPrint = Array.from(xmlElement.getElementsByTagName("cb:FootPrint")).map(element => {
            const PurposeCode = element.attributes?.PurposeCode?.value ?? ''
            const PurposeCodeDesc = element.attributes?.PurposeCodeDesc?.value ?? ''
            const EnquiryTypeCode = element.attributes?.EnquiryTypeCode?.value ?? ''
            const EnquiryTypeDesc = element.attributes?.EnquiryTypeDesc?.value ?? ''
            const EnquiryDate = element.attributes?.EnquiryDate?.value ?? ''
            const InstituteCode = element.attributes?.InstituteCode?.value ?? ''
            const InstituteDesc = element.attributes?.InstituteDesc?.value ?? ''

            return { PurposeCode, PurposeCodeDesc, EnquiryTypeCode, EnquiryTypeDesc, EnquiryDate, InstituteCode, InstituteDesc }
        })
    }

    return { Count1Month, Count3Months, Count6Months, Count12Months, FootPrint };
}

export default footPrints;